import React, { useRef, useEffect } from 'react';
import i18n from '../../i18n/i18n.js';
import Barcode  from 'react-barcode';
import PageHeader from "../../components/PageHeader/PageHeader.js";
import { Utils } from './../../Utils.js';

import './RoyaltyCard.css';

// Egy egyszerű, újrafelhasználható iframe komponens
const IframeEmbed = ({ src, title, settings, ...props }) => {
  // Referencia az iframe DOM-elemre
  const iframeRef = useRef(null);
  
  const intervalRef = useRef(null);

  let auth_hash = '';

  let handleIframeLoad_ok = 0;

  const sendMessageToIframe = () => { 
      if (!!auth_hash && iframeRef.current && iframeRef.current.contentWindow) {
          const targetOrigin = settings.url; // A cél iframe domainje
          const message = {
              type: 'LOGIN_DATA',
              hash: auth_hash,
          };

          iframeRef.current.contentWindow.postMessage(message, targetOrigin);
          //console.log('Post message:', message, targetOrigin);
      }
  };

  // Ez a függvény csak egyszer fut le, az iframe betöltődésekor
  const handleIframeLoad = () => {
    if (handleIframeLoad_ok)
    {
      return;
    }

      // Töröljük a korábbi időzítőt, ha létezik
      if (intervalRef.current) {
          clearInterval(intervalRef.current);
      }

      //console.log('handleIframeLoad');
      sendMessageToIframe();
      
      // Elindítjuk az időzítőt, ami 5 másodpercenként fut
      intervalRef.current = setInterval(() => {
          let auth_hash_expiry = Utils.localSorageGetWithExpiry('auth_hash_expiry');
          //console.log('auth_hash_expiry', auth_hash_expiry, Date.now(), auth_hash_expiry < Date.now());
          if (auth_hash_expiry < Date.now()) {

            Utils.get_server_data(
              '',
              {
                ajax_event:'get_customer_auth_hash',
                APICACHE:'false'
              }, 
              {
                ajax_event: 'get_customer_auth_hash',
                formData: JSON.stringify({}),
              }
            )
            .then((res) => {
              //console.log('get_customer_auth_hash', res);
              auth_hash = res.auth_hash;
              
              sendMessageToIframe();

              Utils.localSorageSetWithExpiry('auth_hash_expiry', res.auth_hash_expiry * 1000, Number.MAX_SAFE_INTEGER);
            });
          }
      },  5000);  
      
      handleIframeLoad_ok = 1;
  };


// useEffect a cleanup-hez: a setInterval leállítása a komponens eltávolításakor
  useEffect(() => {
      return () => {
          if (intervalRef.current) {
              clearInterval(intervalRef.current);
          }
      };
  }, []);

  useEffect(() => {
      // Eseményfigyelő hozzáadása az üzenetek fogadására
      const handleMessage = (event) => {
        console.log('handleMessage', event);
          // Fontos: Mindig ellenőrizd az esemény forrását!
          if (event.origin !== settings.url) {
            //return;
          }

          const { type, payload } = event.data;

          if (type === 'open-content') {
            console.log('open-content in frame', type, payload);

            Utils.get_server_data(
              '/content/' + payload.url, 
              {ajax_event: 'content', APICACHE: 'false'}, 
              {}
            ).then(res => {
              window.modals.PopupContentRef.current.show(res);
            }); 
          }
          else if (type === 'set-default-tvk') {
              console.log('set-default-tvk in frame', type, payload);
              window.AppRef.current.reload_user_data();
          } 
          else if (type === 'iframe-log') {
              // Kiírjuk a logot a szülő alkalmazás konzoljára
              console.log('IFRAME LOG:', ...payload);
          }
          else if (type === 'iframe-error') {
              // Kiírjuk az errort a szülő alkalmazás konzoljára
              console.log('IFRAME ERROR:', ...payload);
          }
      };

      window.addEventListener('message', handleMessage);

      // Cleanup: Eltávolítjuk az eseményfigyelőt, amikor a komponens unmountol
      return () => {
          window.removeEventListener('message', handleMessage);
      };
  }, []); // A [] biztosítja, hogy a useEffect csak egyszer fusson le

  auth_hash = window?.AppRef?.current?.state?.user_data?.auth_hash;

  //console.log('initial auth_hash', auth_hash);

  return (
    <iframe
      ref={iframeRef}
      src={src}
      title={title} // Nagyon fontos az akadálymentesség (accessibility) miatt!
      onLoad={handleIframeLoad}
      {...props}   // Bármilyen más iframe attribútum (width, height, allow, stb.)
      style={{ border: 'none' }} // Opcionális stílus
    />
  );
};

class RoyaltyCard extends React.Component {
  animationObjectRef = new React.createRef();
  
  settings = {};

  constructor(props) {
      super(props);

      this.state = {
        hiding: false,
        show: 0,
      }
  }

  show() {
    window.AppRef.current.get_settings().then((resp)=>{
      this.settings = resp.settings;

      this.setState({show: true}, function() {
        Utils.localSorageSetWithExpiry('auth_hash_expiry', window?.AppRef?.current?.state?.user_data?.auth_hash_expiry * 1000, Number.MAX_SAFE_INTEGER);
      });
    });
  }

  hide() { 
    this.setState({hiding: true}, function() {
      setTimeout(() => {
        this.setState({show: false, hiding: false});
      }, 200);
    }); 
  }

  toggle() {
    if (this.state.show)
    {
      this.hide();
    }
    else {
      this.show();
    }
  }

  render() {
    const ugyfelkartya = window.AppRef.current.state.user_data?.ugyfelkartya;
    const { show, hiding } = this.state;

    if (!show) return '';

    return  <div className={`container floating_container page_royalty_card ${hiding ? 'out' : ''}`}>
    <div className="content">
      
      <PageHeader parent_ref={this} title={i18n.t('customerCard')} />
       
        {this.settings.settings.display_iframe_tvk ?  
          <div className='container_inner'>
            <IframeEmbed
              src={this.settings.settings.url + this.settings.settings.url_royalty_club +  '?in_app_iframe=1'}
              title=""
              settings={this.settings.settings}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div> 
        : ''}

        {!this.settings.settings.display_iframe_tvk ?  
          <div className='container_inner'>
            {ugyfelkartya?.ugyfelkartya_number ? 
                  <div className="customer_card_box_wrapper">
                    <div className="customer_card_box">
                      <label>Dorko Royalty Club</label>
                      <Barcode value={ugyfelkartya.ugyfelkartya_number} />
                    </div>  
                  </div>
            : 
              <div className="customer_card_box_wrapper">
                <p>{i18n.t('getCustomerCard')}</p>
                <a type="button" className="button" target="_blank" href="https://dorko.ugyfelkartya.hu/regisztracio">{i18n.t('getCustomerCardBtn')}</a>
              </div>
            }
          </div> 
        : ''}

      </div>

    </div>;
  }
}

export default RoyaltyCard;

